<template>
  <div>
    <!-- =====================================================
         LOGO SIMULART
    ====================================================== -->
    <v-card
      outlined
      rounded="lg"
      class="pa-4 mb-3"
    >
      <v-img
        :src="require('@/assets/SIMULART_COLOR.svg')"
        alt="simulart logo"
        max-width="150"
        contain
        class="mr-4"
      />
    </v-card>

    <!-- =====================================================
         INFORMACIÓN SIMULART
    ====================================================== -->
    <v-card
      outlined
      rounded="lg"
      class="pa-4 mb-3"
    >
      <div class="content-container">
        <div class="text-body-2 mb-4 text-center">
          SimularT es una empresa consolidada y dinámica, que cuenta con una larga trayectoria en el sector de la energía.
          Formada por un equipo de profesionales altamente capacitados técnica y académicamente,
          con un profundo conocimiento del sector energético, ofrecemos servicios de análisis,
          modelado y consultoría a grandes y medianas empresas del sector energético.
        </div>

        <div class="text-body-2 mb-6 text-center">
          Somos un equipo unido, colaboramos juntos para que nuestros clientes obtengan los mejores resultados.
        </div>

        <div class="d-flex justify-end mb-3">
          <v-img
            :src="require('@/assets/Simulito.png')"
            alt="simulito"
            max-width="120"
            contain
            class="mr-4"
          />
        </div>

        <div class="d-flex justify-end">
          <v-btn
            class="game-link-btn"
            href="https://simulart.es/sobre-nosotros/"
            target="_blank"
          >
            Visitar web

            <span class="material-symbols-outlined ml-2 game-link-icon">
              arrow_outward
            </span>
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- =====================================================
         RECOMPENSA DIARIA
    ====================================================== -->
    <v-card
      outlined
      rounded="lg"
      class="video-reward-card pa-5"
    >
      <div class="content-container">
        <div class="video-reward-header">
          <div>
            <div class="video-reward-title">
              RECOMPENSA DIARIA
            </div>

            <div class="video-reward-subtitle">
              Mira el vídeo completo de SimularT y consigue
              <strong>3.000 €</strong>
            </div>
          </div>

          <div class="reward-amount">
            +3.000 €
          </div>
        </div>

        <!-- CARGANDO -->
        <div
          v-if="loadingStatus"
          class="text-center py-4"
        >
          <v-progress-circular
            indeterminate
            size="28"
          />

          <div class="mt-2 text-caption">
            Comprobando recompensa...
          </div>
        </div>

        <!-- YA COBRADO -->
        <div
          v-else-if="claimed"
          class="reward-completed"
        >
          <span class="material-symbols-outlined reward-check">
            check_circle
          </span>

          <div>
            <div class="reward-completed-title">
              Recompensa conseguida
            </div>

            <div class="reward-completed-text">
              Ya has recibido los 3.000 € de hoy.
              Vuelve mañana para conseguir otra recompensa.
            </div>
          </div>
        </div>

        <!-- DISPONIBLE -->
        <div
          v-else
          class="d-flex justify-center mt-5"
        >
          <v-btn
            class="watch-video-btn"
            :loading="startingVideo"
            :disabled="startingVideo"
            @click="startVideoReward"
          >
            <span class="material-symbols-outlined mr-2">
              play_circle
            </span>

            Ver vídeo y ganar 3.000 €
          </v-btn>
        </div>

        <div
          v-if="errorMessage"
          class="video-error mt-4"
        >
          {{ errorMessage }}
        </div>
      </div>
    </v-card>

    <!-- =====================================================
         MODAL DEL VÍDEO
    ====================================================== -->
    <v-dialog
      v-model="videoDialog"
      max-width="850"
      persistent
    >
      <v-card class="video-dialog-card">
        <v-card-title class="video-dialog-header">
          <div>
            <div class="video-dialog-title">
              {{"Vídeo" }}
            </div>

            <div class="video-dialog-reward">
              Mira el vídeo completo para conseguir +3.000 €
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pa-4">
          <div
            v-if="video"
            class="video-wrapper"
          >
            <video
              ref="rewardVideo"
              :key="video.url"
              class="reward-video"
              controls
              playsinline
              preload="auto"
              controlsList="nodownload"
              @ended="onVideoEnded"
              @error="onVideoError"
              @loadedmetadata="onVideoLoaded"
            >
              <source
                :src="video.url"
                type="video/mp4"
              >
              Tu navegador no soporta reproducción de vídeo.
            </video>
          </div>

          <div
            v-if="claimingReward"
            class="text-center mt-4"
          >
            <v-progress-circular
              indeterminate
              size="24"
            />

            <div class="mt-2">
              Entregando recompensa...
            </div>
          </div>

          <div
            v-if="videoCompleted && !claimingReward"
            class="video-success mt-4"
          >
            <span class="material-symbols-outlined">
              check_circle
            </span>

            Has conseguido 3.000 €
          </div>

          <div
            v-if="dialogError"
            class="video-error mt-4"
          >
            {{ dialogError }}
          </div>
        </v-card-text>

        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            :disabled="claimingReward"
            @click="closeVideoDialog"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "AboutUs",

  data() {
    return {
      loadingStatus: true,
      startingVideo: false,
      claimingReward: false,

      claimed: false,

      videoDialog: false,
      video: null,

      videoCompleted: false,

      errorMessage: "",
      dialogError: "",
    };
  },

  mounted() {
    this.loadVideoRewardStatus();
  },

  methods: {
    onVideoLoaded() {
  const player = this.$refs.rewardVideo;

  console.log("Vídeo cargado correctamente:", {
    url: this.video?.url,
    duration: player?.duration,
    readyState: player?.readyState,
    networkState: player?.networkState,
  });
},

onVideoError() {
  const player = this.$refs.rewardVideo;
  const error = player?.error;

  console.error("Error cargando vídeo de recompensa:", {
    url: this.video?.url,
    code: error?.code,
    message: error?.message,
    networkState: player?.networkState,
    readyState: player?.readyState,
  });

  this.dialogError =
    "No se ha podido cargar el vídeo. Cierra esta ventana e inténtalo de nuevo.";
},
    // =====================================================
    // EXTRAER DATA DE JSEND
    // =====================================================
    unwrapResponse(response) {
      if (
        response &&
        response.data &&
        response.data.data !== undefined
      ) {
        return response.data.data;
      }

      return response?.data || {};
    },

    // =====================================================
    // ESTADO DE LA RECOMPENSA
    // =====================================================
    async loadVideoRewardStatus() {
      this.loadingStatus = true;
      this.errorMessage = "";

      try {
        const response = await axios.get(
          "/api/video-reward/status"
        );

        const data = this.unwrapResponse(
          response
        );

        this.claimed = Boolean(
          data.claimed
        );

        if (data.video) {
          this.video = data.video;
        }
      } catch (error) {
        console.error(
          "Error consultando recompensa de vídeo:",
          error
        );

        this.errorMessage =
          "No se ha podido consultar la recompensa diaria.";
      } finally {
        this.loadingStatus = false;
      }
    },

    // =====================================================
    // INICIAR VÍDEO
    // =====================================================
    async startVideoReward() {
      if (this.startingVideo) {
        return;
      }

      this.startingVideo = true;
      this.errorMessage = "";
      this.dialogError = "";
      this.videoCompleted = false;

      try {
        const response = await axios.post(
          "/api/video-reward/start",
          {}
        );

        const data = this.unwrapResponse(
          response
        );

        if (data.claimed) {
          this.claimed = true;
          return;
        }

        if (!data.video) {
          throw new Error(
            "El backend no ha devuelto ningún vídeo."
          );
        }

        this.video = data.video;
        console.log("Vídeo recibido del backend:", data.video);

        this.videoDialog = true;

        // Esperamos a que el diálogo y el vídeo
        // estén montados antes de reiniciarlo.
        this.$nextTick(() => {
          const player = this.$refs.rewardVideo;

          if (player) {
            player.load();
            player.currentTime = 0;
          }
        });
      } catch (error) {
        console.error(
          "Error iniciando vídeo:",
          error
        );

        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.data?.message;

        this.errorMessage =
          backendMessage ||
          "No se ha podido iniciar el vídeo.";
      } finally {
        this.startingVideo = false;
      }
    },

    // =====================================================
    // VÍDEO TERMINADO
    // =====================================================
    async onVideoEnded() {
      if (
        this.claimingReward ||
        this.claimed
      ) {
        return;
      }

      this.videoCompleted = true;

      await this.claimVideoReward();
    },

    // =====================================================
    // COBRAR RECOMPENSA
    // =====================================================
    async claimVideoReward() {
      this.claimingReward = true;
      this.dialogError = "";

      try {
        const response = await axios.post(
          "/api/video-reward/claim",
          {}
        );

        const data = this.unwrapResponse(
          response
        );

        this.claimed = true;
        this.videoCompleted = true;

        console.log(
          "Recompensa vídeo recibida:",
          data
        );

        // Dejamos un momento el mensaje de éxito
        // antes de cerrar automáticamente.
        setTimeout(() => {
          this.videoDialog = false;
        }, 1500);
      } catch (error) {
        console.error(
          "Error reclamando recompensa:",
          error
        );

        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.data?.message;

        this.dialogError =
          backendMessage ||
          "No se ha podido entregar la recompensa.";
      } finally {
        this.claimingReward = false;
      }
    },

    // =====================================================
    // CERRAR MODAL
    // =====================================================
    closeVideoDialog() {
      const player =
        this.$refs.rewardVideo;

      if (player) {
        player.pause();
      }

      this.videoDialog = false;
    },
  },
};
</script>

<style scoped>
.text-body-2 {
  line-height: 1.6;
}

.content-container {
  max-width: 600px;
  margin: 0 auto;
}

/* =========================================================
   BOTÓN WEB SIMULART
========================================================= */

.game-link-btn {
  height: 40px !important;
  padding: 0 18px !important;
  border-radius: 999px !important;
  color: #06111f !important;
  font-family: "Orbitron", sans-serif !important;
  font-size: 12px !important;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: linear-gradient(
    90deg,
    #22c55e,
    #38bdf8
  ) !important;
  box-shadow:
    0 0 14px rgba(56, 189, 248, 0.35),
    0 8px 22px rgba(49, 99, 95, 0.16);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    filter 0.2s ease;
}

.game-link-btn:hover {
  transform: translateY(-1px) scale(1.02);
  box-shadow:
    0 0 20px rgba(56, 189, 248, 0.55),
    0 10px 28px rgba(49, 99, 95, 0.22);
  filter: brightness(1.05);
}

.game-link-icon {
  font-size: 17px !important;
}

/* =========================================================
   RECOMPENSA DIARIA
========================================================= */

.video-reward-card {
  overflow: hidden;
}

.video-reward-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.video-reward-title {
  font-family: "Orbitron", sans-serif;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.8px;
}

.video-reward-subtitle {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
}

.reward-amount {
  flex-shrink: 0;
  font-family: "Orbitron", sans-serif;
  font-size: 19px;
  font-weight: 900;
}

.watch-video-btn {
  min-height: 44px !important;
  padding: 0 22px !important;
  border-radius: 999px !important;

  font-family: "Orbitron", sans-serif !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  letter-spacing: 0.5px;

  color: #06111f !important;

  background: linear-gradient(
    90deg,
    #22c55e,
    #38bdf8
  ) !important;

  box-shadow:
    0 0 14px rgba(56, 189, 248, 0.35),
    0 8px 22px rgba(49, 99, 95, 0.16);
}

.reward-completed {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 15px;
  border-radius: 12px;
  background: rgba(34, 197, 94, 0.1);
}

.reward-check {
  font-size: 32px;
}

.reward-completed-title {
  font-family: "Orbitron", sans-serif;
  font-size: 13px;
  font-weight: 900;
}

.reward-completed-text {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.4;
}

/* =========================================================
   MODAL VÍDEO
========================================================= */

.video-dialog-card {
  overflow: hidden;
}

.video-dialog-header {
  padding: 18px 20px;
}

.video-dialog-title {
  font-family: "Orbitron", sans-serif;
  font-size: 15px;
  font-weight: 900;
}

.video-dialog-reward {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.8;
}

.video-wrapper {
  width: 100%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.reward-video {
  display: block;
  width: 100%;
  max-height: 65vh;
  background: #000;
}

.video-success {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  font-family: "Orbitron", sans-serif;
  font-size: 13px;
  font-weight: 900;
}

.video-error {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  text-align: center;
  background: rgba(239, 68, 68, 0.1);
}

/* =========================================================
   MÓVIL
========================================================= */

@media (max-width: 600px) {
  .video-reward-header {
    flex-direction: column;
    text-align: center;
  }

  .watch-video-btn {
    width: 100%;
    font-size: 10px !important;
  }

  .reward-amount {
    font-size: 18px;
  }
}
</style>